/**
 * Route for `drag-to-reorder-dashboard-layout`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DragToReorderDashboardLayoutPage } from "../features/drag-to-reorder-dashboard-layout/DragToReorderDashboardLayoutPage";

export const dragToReorderDashboardLayoutRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/drag-to-reorder-dashboard-layout",
	component: DragToReorderDashboardLayoutPage,
});

export default dragToReorderDashboardLayoutRoute;
